// The fallback for autoUpdate.ts: a newer build is deployed, but reloading
// would have eaten a half-typed message or interrupted a live reply. Rather
// than reload anyway, offer the choice — and keep offering it, because the
// alternative is running yesterday's code without knowing.
//
// It stays out of the way: one small pill above the composer, no overlay, no
// modal. If he ignores it, autoUpdate reloads on its own the next time the app
// becomes visible with an empty composer.

import { useEffect, useState } from "react";
import { startAutoUpdate, updatePending } from "../lib/autoUpdate";

export default function UpdatePill() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    startAutoUpdate(() => setShow(true));
    // Covers the case where the update was detected before this mounted.
    if (updatePending()) setShow(true);
  }, []);

  if (!show) return null;

  return (
    <button
      type="button"
      className="updatePill"
      onClick={() => location.reload()}
      aria-label="A new version is available — tap to update"
    >
      New version ready · tap to update
    </button>
  );
}
